<template>
    <b-form-group
        label="Email address"
        label-class="font-weight-bold"
    >
        <b-input-group>
            <b-input-group-prepend>
                <b-input-group-text>
                    <font-awesome-icon
                        icon="envelope"
                        :size="size == 'lg' ? size : 'sm'"
                    />
                </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
                placeholder="Email address"
                :value="value"
                @input="(value) => $emit('input', value)"
                type="email"
                required
                :disabled="disabled"
                :size="size"
                @keyup.enter="$emit('submit')"
            />
            <b-input-group-append
                v-if="disabled"
            >
                <b-input-group-text>
                    <router-link
                        :to="{ name: 'login' }"
                    >
                        Change
                    </router-link>
                </b-input-group-text>
            </b-input-group-append>
        </b-input-group>
    </b-form-group>
</template>
<script>
export default {
    props: {
        value: String,
        disabled: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: "md",
            validator(value) {
                return ["lg", "md", "sm"].includes(value);
            }
        }
    }
}
</script>